module.exports = __webpack_public_path__ + "static/img/2.cb65482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newThree/2.png
// module id = N6Z6
// module chunks = 0